import { IExpression } from '../IExpression';
import { ExpressionRepository } from '../repository/ExpressionsRepository';
import { expressionLogger } from '../utils/expressionLogger';
import { IReference } from './IReference';

/**
 * Ottiene tutte le Reference utilizzate in un'espressione.
 *
 * Nota: Se necessario, questa funzione può essere ottimizzata per le
 * performance con una queue e una BFS
 */
export function collectExpressionReferences(
  expression: IExpression | null | undefined,
): IReference[] {
  if (expression == null) return [];

  const expressionType = ExpressionRepository.get(expression.type);
  if (!expressionType) {
    expressionLogger.warn(`[collectExpressionReferences] Expression type not found`, expression); // prettier-ignore
    return [];
  }

  const references = expressionType.getReferences(
    expression,
    collectExpressionReferences,
  );
  return references;
}
